import routes from './articleRoutes.generated.json';

/**
 * The routing surface of the content hub, kept separate from the content itself.
 *
 * App.js and Navbar need slugs; they do not need ~250 kB of prose. Importing the
 * full bundle here would pull every article into the main chunk and make the
 * landing page carry the whole hub. Everything heavy lives in `articles.js`, which
 * only an article route loads.
 */

export const ARTICLE_SLUGS = routes.slugs;

/** Author ids with a page at /authors/<id> (SEO phase 1). */
export const AUTHOR_IDS = routes.authorIds || [];

/** Where the navbar's "Articles" link points. Derived from content, so when the
 *  top-level pillar is written it becomes the entry point without a code change. */
export const CONTENT_HUB_SLUG = routes.hubSlug;
